import React from "react";
import SettingsIcon from "@assets/icons/cog.svg?react";
import HelpIcon from "@assets/icons/help.svg?react";
import { AuthButton } from "@shared/Toolbar/AuthButton/AuthButton";
import { NewToolbarButton } from "@shared/Toolbar/NewToolbarButton";
import { uiState } from "@shared/states/uiStates";

export const MobileNavbar = () => {
	return (
		<div
			className={
				"flex items-center justify-between h-12 px-3 bg-base-200 border-b border-border-base-200"
			}
		>
			<div className={"text-white font-bold text-lg"}>RiftKit</div>
			<div className={"flex items-center gap-1"}>
				<NewToolbarButton
					onClick={() => (uiState.modal = "settings")}
					tooltipMessage={"Settings"}
					testId={"mobile-nav-settings"}
				>
					<SettingsIcon width={28} height={28} />
				</NewToolbarButton>
				<NewToolbarButton
					onClick={() => (uiState.modal = "help")}
					tooltipMessage={"Help"}
					testId={"mobile-nav-help"}
				>
					<HelpIcon width={28} height={28} />
				</NewToolbarButton>
				<AuthButton positions={["bottom", "left"]} />
			</div>
		</div>
	);
};
